import type { ReactNode } from "react";

import { useTranslation } from "@/localization/hooks/use-translation";

// The table's columns, shared by its header and every row through CSS subgrid,
// so a title, artist and length line up down the whole list.
const TRACK_TABLE_COLUMNS_CLASS_NAME = "grid-cols-[2rem_minmax(0,3fr)_minmax(0,2fr)_4rem]";

// One row of the table, laid onto its columns.
export const TRACK_TABLE_ROW_CLASS_NAME = "col-span-full grid grid-cols-subgrid items-center px-3";

/**
 * A project's tracks as a table: one row per track, a column each for the
 * position, title, artist and length — the table the desktop's Tracklist and
 * Music catalog draw, so the same album reads the same way in both
 * applications. Its rows are `li`s carrying `TRACK_TABLE_ROW_CLASS_NAME`.
 */
export const TrackTable = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();

  return (
    <div className={`grid gap-x-3 ${TRACK_TABLE_COLUMNS_CLASS_NAME}`}>
      <div className="col-span-full grid grid-cols-subgrid items-center border-b border-border bg-muted/40 px-3 py-2 text-xs font-semibold tracking-wider text-muted-foreground uppercase">
        <span className="text-center">{t("catalog.column.position")}</span>
        <span>{t("catalog.column.title")}</span>
        <span>{t("catalog.column.artist")}</span>
        <span className="text-right">{t("catalog.column.length")}</span>
      </div>
      <ol className="col-span-full grid grid-cols-subgrid divide-y divide-border">{children}</ol>
    </div>
  );
};
